import BaseCheckbox, {
  CheckboxChangeEvent,
  CheckboxProps as BaseCheckboxProps,
} from 'antd/lib/checkbox'

export type { CheckboxChangeEvent }

export interface CheckboxProps extends BaseCheckboxProps {}

export const Checkbox = (props: CheckboxProps): JSX.Element => (
  <>
    <BaseCheckbox {...props} />
  </>
)
